<div class="dx-card">
  <dx-form
    #calcForm
    id="calculationForm"
    labelMode="floating"
    [(formData)]="calculationData"
    [colCount]="1"
    [colCountByScreen]="{ xs: 1 }"
    validationGroup="newCalculationFormValidation"
    (onFieldDataChanged)="onFormFieldChanged()"
  >
    <dxi-item itemType="group" [colCount]="6" [colCountByScreen]="{ xs: 1 }">
      <dxi-item style="padding-top: 1.5em" [colSpan]="2"
        ><span
          class="d-flex flex-shrink flex-column form-headline"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
          >General Information</span
        ></dxi-item
      >
      <dxi-item [colSpan]="3" itemType="empty"> <!-- placeholder --> </dxi-item>
      <dxi-item name="date" [colSpan]="1">
        <div *dxTemplate="let data">
          <dx-text-box
            stylingMode="underlined"
            [label]="formatMessage('calculator.calculation.us.date') + ' *'"
            [(value)]="
              getTodaysDate() || data.component.option('formData')[data.name]
            "
            [readOnly]="true"
          ></dx-text-box>
        </div>
      </dxi-item>
      <dxi-item
        dataField="author"
        [label]="{ text: formatMessage('calculator.calculation.us.author') }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="2"
      >
      </dxi-item>
      <dxi-item
        dataField="title"
        [label]="{ text: formatMessage('calculator.calculation.us.title') }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="4"
      >
      </dxi-item>
      <dxi-item name="publisher" [colSpan]="2">
        <div *dxTemplate="let data">
          <dx-select-box
            stylingMode="underlined"
            [label]="
              formatMessage('calculator.calculation.us.publisher') + ' *'
            "
            [dataSource]="organizations"
            displayExpr="displayName"
            [searchEnabled]="true"
            [(value)]="selectedPublisher"
            (onValueChanged)="publisherSelected($event)"
          ></dx-select-box>
        </div>
        <dxi-validation-rule
          type="required"
          [message]="formatMessage('validation.required')"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        dataField="customerContact"
        [label]="{
          text: formatMessage('calculator.calculation.us.customerContact')
        }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="2"
      >
      </dxi-item>
      <dxi-item
        dataField="bpgContact"
        [label]="{
          text: formatMessage('calculator.calculation.us.bpgContact')
        }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="2"
      >
      </dxi-item>
      <!--
      TODO: Not needed
      <dxi-item
        dataField="printNumber"
        [label]="{
          text: formatMessage('calculator.calculation.us.printNumber')
        }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="2"
      >
      </dxi-item>
      -->
    </dxi-item>
    <dxi-item itemType="group" [colCount]="6" [colCountByScreen]="{ xs: 1 }">
      <dxi-item style="padding-top: 1.5em" [colSpan]="2"
        ><span
          class="d-flex flex-shrink flex-column form-headline"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
          >Job Specifications</span
        ></dxi-item
      >
      <dxi-item [colSpan]="4" itemType="empty"> <!-- placeholder --> </dxi-item>
      <dxi-item
        dataField="quantity[0]"
        [label]="{
          text: formatMessage('calculator.calculation.us.quantity') + ' 1'
        }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="2"
      >
        <dxi-validation-rule
          type="required"
          [message]="formatMessage('validation.required')"
        ></dxi-validation-rule>
        <dxi-validation-rule type="numeric"></dxi-validation-rule>
        <dxi-validation-rule
          type="range"
          [min]="1"
          [message]="
            formatMessage('calculator.calculation.validation.quantity.range')
          "
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        dataField="quantity[1]"
        [label]="{
          text: formatMessage('calculator.calculation.us.quantity') + ' 2'
        }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="2"
      >
        <dxi-validation-rule
          *ngIf="!!calculationData?.quantity?.[2]"
          type="required"
          [message]="formatMessage('validation.required')"
        ></dxi-validation-rule>
        <dxi-validation-rule type="numeric"></dxi-validation-rule>
        <dxi-validation-rule
          type="range"
          [min]="1"
          [message]="
            formatMessage('calculator.calculation.validation.quantity.range')
          "
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        dataField="quantity[2]"
        [label]="{
          text: formatMessage('calculator.calculation.us.quantity') + ' 3'
        }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="2"
      >
        <dxi-validation-rule type="numeric"></dxi-validation-rule>
        <dxi-validation-rule
          type="range"
          [min]="1"
          [message]="
            formatMessage('calculator.calculation.validation.quantity.range')
          "
        ></dxi-validation-rule>
      </dxi-item>

      <dxi-item [colSpan]="6" itemType="empty"> <!-- placeholder --> </dxi-item>
      <dxi-item name="product" [colSpan]="2">
        <div *dxTemplate="let data">
          <dx-select-box
            stylingMode="underlined"
            [label]="formatMessage('calculator.calculation.us.product') + ' *'"
            [dataSource]="products"
            displayExpr="name"
            [(value)]="selectedProduct"
            (onValueChanged)="productSelected($event)"
          ></dx-select-box>
        </div>
        <dxi-validation-rule
          type="required"
          [message]="formatMessage('validation.required')"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        dataField="trimSizeGroup"
        [colSpan]="2"
        [label]="{
          text: formatMessage('calculator.calculation.us.trimSizeGroup')
        }"
        [editorOptions]="{
          stylingMode: 'underlined',
          readOnly: true
        }"
      >
      </dxi-item>
      <dxi-item [colSpan]="2" itemType="empty"> <!-- placeholder --> </dxi-item>
      <dxi-item
        dataField="binding"
        [colSpan]="1"
        *ngIf="!calculationData.pressMethod"
        [editorOptions]="{
          stylingMode: 'underlined',
          label: formatMessage('calculator.calculation.us.binding'),
          dataSource: calculatorUsFormDropdownValues.bindingValues,
          valueExpr: 'value',
          displayExpr: 'displayExpr',
          readOnly: true
        }"
        editorType="dxSelectBox"
      >
      </dxi-item>

      <dxi-item
        dataField="pressMethod"
        [colSpan]="1"
        *ngIf="calculationData.pressMethod"
        [editorOptions]="{
          stylingMode: 'underlined',
          label: formatMessage('calculator.calculation.us.pressMethod'),
          dataSource: calculatorUsFormDropdownValues.pressMethodValues,
          valueExpr: 'value',
          displayExpr: 'displayExpr',
          readOnly: true
        }"
        editorType="dxSelectBox"
      >
      </dxi-item>
      <dxi-item
        dataField="edition"
        [colSpan]="1"
        [editorOptions]="{
          stylingMode: 'underlined',
          label: formatMessage('calculator.calculation.us.edition'),
          dataSource: calculatorUsFormDropdownValues.editionValues,
          valueExpr: 'value',
          displayExpr: 'displayExpr',
          readOnly: true
        }"
        editorType="dxSelectBox"
      >
      </dxi-item>

      <dxi-item dataField="width" name="width" [colSpan]="1">
        <div *dxTemplate="let data">
          <dx-text-box
            stylingMode="underlined"
            [label]="formatMessage('calculator.calculation.us.width') + ' *'"
            [(value)]="data.component.option('formData')[data.name]"
            [readOnly]="!selectedProduct"
            (onValueChanged)="validateWidth()"
          ></dx-text-box>
        </div>
        <dxi-validation-rule
          *ngIf="!!selectedProduct"
          type="required"
          [message]="formatMessage('validation.required')"
        ></dxi-validation-rule>

        <dxi-validation-rule
          type="custom"
          [validationCallback]="validateWidth"
          [message]="widthValidationMessage"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item dataField="height" name="height" [colSpan]="1">
        <div *dxTemplate="let data">
          <dx-text-box
            stylingMode="underlined"
            [label]="formatMessage('calculator.calculation.us.height') + ' *'"
            [(value)]="data.component.option('formData')[data.name]"
            [readOnly]="!selectedProduct"
            (onValueChanged)="validateHeight()"
          ></dx-text-box>
        </div>
        <dxi-validation-rule
          *ngIf="!!selectedProduct"
          type="required"
          [message]="formatMessage('validation.required')"
        ></dxi-validation-rule>
        <dxi-validation-rule type="numeric"></dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          [validationCallback]="validateHeight"
          [message]="heightValidationMessage"
        ></dxi-validation-rule>
      </dxi-item>

      <dxi-item name="pages" [colSpan]="1">
        <div *dxTemplate="let data">
          <dx-select-box
            stylingMode="underlined"
            [label]="formatMessage('calculator.calculation.us.pages') + ' *'"
            [dataSource]="pageDropdownDataSource"
            [readOnly]="!pageDropdownDataSource"
            [searchEnabled]="true"
            [(value)]="data.component.option('formData')[data.name]"
          ></dx-select-box>
        </div>
        <dxi-validation-rule
          type="required"
          [message]="formatMessage('validation.required')"
        ></dxi-validation-rule>
      </dxi-item>

      <dxi-item
        dataField="reprint"
        [colSpan]="1"
        [editorOptions]="{
          stylingMode: 'underlined',
          label:
            formatMessage('calculator.calculation.us.initialOrReprint') + ' *',
          dataSource: calculatorUsFormDropdownValues.initialOrReprintValues,
          valueExpr: 'value',
          displayExpr: 'displayExpr',
          readOnly: true
        }"
        editorType="dxSelectBox"
      >
        <!-- Dont needed
        <div *dxTemplate="let data">
          <dx-select-box
            stylingMode="underlined"
            [label]="
              formatMessage('calculator.calculation.us.initialOrReprint') + ' *'"
            [dataSource]="calculatorUsFormDropdownValues.initialOrReprintValues"
            displayExpr="displayExpr"
            valueExpr="value"
            [(value)]="data.component.option('formData')[data.name]"
          ></dx-select-box>
        </div>
        -->
      </dxi-item>

      <dxi-item [colSpan]="6" itemType="empty"> <!-- placeholder --> </dxi-item>

      <dxi-item
        *ngIf="usedCartonPackOption?.cartonColumnNames[0]"
        name="cartonOrPacks"
        [colSpan]="2"
      >
        <div *dxTemplate="let data">
          <dx-select-box
            stylingMode="underlined"
            [label]="
              formatMessage('calculator.calculation.us.cartonPacks') + ' *'
            "
            [dataSource]="usedCartonPackOption?.cartonColumnNames"
            [(value)]="selectedCartonPack"
            (onSelectionChanged)="onCartonPackSelected($event)"
            (onFocusIn)="onCartonPackFocusIn()"
          ></dx-select-box>
        </div>
        <dxi-validation-rule
          type="required"
          [message]="formatMessage('validation.required')"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        *ngIf="!usedCartonPackOption?.cartonColumnNames[0]"
        name="cartonOrPacks"
        [colSpan]="2"
      >
        <div *dxTemplate="let data">
          <dx-text-box
            [label]="
              formatMessage('calculator.calculation.us.cartonPacks') + ' *'
            "
            stylingMode="underlined"
            [readOnly]="true"
            [value]="selectedProduct ? 'Cartons / Pack' : ''"
          >
          </dx-text-box>
        </div>
      </dxi-item>
      <dxi-item name="paper" [colSpan]="2">
        <div *dxTemplate="let data">
          <dx-select-box
            stylingMode="underlined"
            [label]="formatMessage('calculator.calculation.us.paper')"
            [dataSource]="calculatorUsFormDropdownValues.paperSpecsValues"
            displayExpr="displayExpr"
            valueExpr="value"
            [(value)]="data.component.option('formData')[data.name]"
          ></dx-select-box>
        </div>
      </dxi-item>
      <dxi-item
        dataField="paperInLb"
        [label]="{
          text: formatMessage('calculator.calculation.us.paperInLb')
        }"
        [editorOptions]="{
          stylingMode: 'underlined'
        }"
        [colSpan]="2"
      >
      </dxi-item>

      <!-- Split container and content to manually reload the dropdown due to a devextreme bug -->
      <ng-container
        style=""
        #dropDowns
        [ngTemplateOutlet]="dropDownContentRef"
        *ngIf="false"
      ></ng-container>
      <ng-template #loadIndicator>
        <dxi-item #idleItem [colSpan]="6">
          <div
            *dxTemplate="let data"
            style="display: flex; justify-content: center"
          >
            <dx-load-indicator [height]="40" [width]="40"> </dx-load-indicator>
          </div>
        </dxi-item>
      </ng-template>
      <ng-template #dropDownContent>
        <dxi-item [colSpan]="6" itemType="empty"> </dxi-item>
        <dxi-item dataField="prep" [colSpan]="prepWidth">
          <div class="dx-field-label line-height-center">
            <label>{{ formatMessage("calculator.calculation.us.prep") }}</label>
          </div>
          <div class="dx-field-value">
            <dx-drop-down-box
              [(value)]="calculationData.prep"
              valueExpr="id"
              displayExpr="displayExpr"
              placeholder="Select preparation method..."
              [showClearButton]="true"
              [dataSource]="prepDataSource"
              (onValueChanged)="onDropDownBoxValueChanged($event, 'prep')"
              valueChangeEvent=""
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  #prepTree
                  [dataSource]="prepDataSource"
                  dataStructure="plain"
                  keyExpr="id"
                  parentIdExpr="categoryId"
                  selectionMode="single"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTreeViewSelectionChanged($event, 'prep')
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>

        <dxi-item dataField="proofText" [colSpan]="proofTextWidth">
          <div class="dx-field-label line-height-center">
            <label>{{
              formatMessage("calculator.calculation.us.proofText")
            }}</label>
          </div>
          <div class="dx-field-value">
            <dx-drop-down-box
              #proofTextDropdown
              [(value)]="calculationData.proofText"
              valueExpr="id"
              displayExpr="displayExpr"
              placeholder="Select proof text..."
              [showClearButton]="true"
              [dataSource]="proofTextDataSource"
              (onValueChanged)="onDropDownBoxValueChanged($event, 'proofText')"
              valueChangeEvent=""
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  #proofTree
                  [dataSource]="proofTextDataSource"
                  dataStructure="plain"
                  keyExpr="id"
                  parentIdExpr="categoryId"
                  selectionMode="single"
                  showCheckBoxesMode="normal"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTreeViewSelectionChanged($event, 'proofText')
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>

        <dxi-item dataField="paperText" [colSpan]="paperTextWidth">
          <div class="dx-field-label line-height-center">
            <label>{{
              formatMessage("calculator.calculation.us.paperText")
            }}</label>
          </div>
          <div class="dx-field-value">
            <dx-drop-down-box
              [(value)]="calculationData.paperText"
              valueExpr="id"
              displayExpr="displayExpr"
              placeholder="Select print text..."
              [showClearButton]="true"
              [dataSource]="paperTextDataSource"
              title="Please select a case style from the list"
              (onValueChanged)="onDropDownBoxValueChanged($event, 'paperText')"
              valueChangeEvent=""
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  #printTree
                  [dataSource]="paperTextDataSource"
                  dataStructure="plain"
                  keyExpr="id"
                  parentIdExpr="categoryId"
                  selectionMode="single"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTreeViewSelectionChanged($event, 'paperText')
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>

        <dxi-item dataField="printText" [colSpan]="printTextWidth">
          <div class="dx-field-label line-height-center">
            <label>{{
              formatMessage("calculator.calculation.us.printText")
            }}</label>
          </div>
          <div class="dx-field-value">
            <dx-drop-down-box
              [(value)]="calculationData.printText"
              valueExpr="id"
              displayExpr="displayExpr"
              placeholder="Select print text..."
              [showClearButton]="true"
              [dataSource]="printTextDataSource"
              (onValueChanged)="onDropDownBoxValueChanged($event, 'printText')"
              valueChangeEvent=""
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  #printTree
                  [dataSource]="printTextDataSource"
                  dataStructure="plain"
                  keyExpr="id"
                  parentIdExpr="categoryId"
                  selectionMode="single"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTreeViewSelectionChanged($event, 'printText')
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>

        <dxi-item dataField="bind" [colSpan]="bindWidth">
          <div class="dx-field-label line-height-center">
            <label>{{ formatMessage("calculator.calculation.us.bind") }}</label>
          </div>
          <div class="dx-field-value">
            <dx-drop-down-box
              [(value)]="calculationData.bind"
              valueExpr="id"
              displayExpr="displayExpr"
              placeholder="Select binding type..."
              [showClearButton]="true"
              [dataSource]="bindDataSource"
              (onValueChanged)="onDropDownBoxValueChanged($event, 'bind')"
              valueChangeEvent=""
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  #bindTree
                  [dataSource]="bindDataSource"
                  dataStructure="plain"
                  keyExpr="id"
                  parentIdExpr="categoryId"
                  selectionMode="single"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTreeViewSelectionChanged($event, 'bind')
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>

        <dxi-item
          itemType="group"
          [colSpan]="caseStyleWidth"
          cssClass="calc-form-input-group"
        >
          <dxi-item itemType="group">
            <dxi-item dataField="shipment">
              <div class="dx-field-label line-height-center">
                <label>{{
                  formatMessage("calculator.calculation.us.caseStyle")
                }}</label>
              </div>
              <div class="dx-field-value">
                <dx-drop-down-box
                  [(value)]="calculationData.caseStyle"
                  valueExpr="id"
                  displayExpr="displayExpr"
                  placeholder="Select case style..."
                  [showClearButton]="true"
                  [dataSource]="caseStyleDataSource"
                  (onValueChanged)="
                    onDropDownBoxValueChanged($event, 'caseStyle')
                  "
                  valueChangeEvent=""
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      #caseStyleTree
                      [dataSource]="caseStyleDataSource"
                      dataStructure="plain"
                      keyExpr="id"
                      parentIdExpr="categoryId"
                      selectionMode="single"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="
                        onTreeViewSelectionChanged($event, 'caseStyle')
                      "
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" cssClass="calc-form-input-item">
            <dxi-item
              [visible]="collectedAdditionalInformation?.caseStyle?.['requiresInput'] == true"
              itemType="group"
              name="caseStyleInput"
            >
              <dxi-item
                [visible]="collectedAdditionalInformation?.caseStyle?.['requiresCaseSize'] == true"
                editorType="dxTextBox"
                dataField="requiredInput.caseStyleSize"
                cssClass="calc-form-input-item"
              >
                <dxo-label text="Size"></dxo-label>
              </dxi-item>
              <dxi-item
                [visible]="collectedAdditionalInformation?.caseStyle?.['requiresFrontAndSpineSize'] == true"
                editorType="dxTextBox"
                dataField="requiredInput.caseStyleFrontSize"
                cssClass="calc-form-input-item"
              >
                <dxo-label text="Front Size"> </dxo-label>
              </dxi-item>
              <dxi-item
                [visible]="collectedAdditionalInformation?.caseStyle?.['requiresFrontAndSpineSize'] == true"
                editorType="dxTextBox"
                dataField="requiredInput.caseStyleSpineSize"
                cssClass="calc-form-input-item"
              >
                <dxo-label text="Spine Size"> </dxo-label>
              </dxi-item>
            </dxi-item>
          </dxi-item>
        </dxi-item>

        <dxi-item dataField="boards" [colSpan]="boardsWidth">
          <div class="dx-field-label line-height-center">
            <label>{{
              formatMessage("calculator.calculation.us.boards")
            }}</label>
          </div>
          <div class="dx-field-value">
            <dx-drop-down-box
              [(value)]="calculationData.boards"
              valueExpr="id"
              displayExpr="displayExpr"
              placeholder="Select board type..."
              [showClearButton]="true"
              [dataSource]="boardsDataSource"
              (onValueChanged)="onDropDownBoxValueChanged($event, 'boards')"
              valueChangeEvent=""
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  #boardsTree
                  [dataSource]="boardsDataSource"
                  dataStructure="plain"
                  keyExpr="id"
                  parentIdExpr="categoryId"
                  selectionMode="single"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTreeViewSelectionChanged($event, 'boards')
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>

        <dxi-item
          itemType="group"
          [colSpan]="endpapersWidth"
          cssClass="calc-form-input-group"
        >
          <dxi-item itemType="group">
            <dxi-item dataField="endpapers">
              <div class="dx-field-label line-height-center">
                <label>{{
                  formatMessage("calculator.calculation.us.endpapers")
                }}</label>
              </div>
              <div class="dx-field-value">
                <dx-drop-down-box
                  [(value)]="calculationData.endpapers"
                  valueExpr="id"
                  displayExpr="displayExpr"
                  placeholder="Select endpapers..."
                  [showClearButton]="true"
                  [dataSource]="endpapersDataSource"
                  (onValueChanged)="
                    onDropDownBoxValueChanged($event, 'endpapers')
                  "
                  valueChangeEvent=""
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      #endpapersTree
                      [dataSource]="endpapersDataSource"
                      dataStructure="plain"
                      keyExpr="id"
                      parentIdExpr="categoryId"
                      selectionMode="single"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="
                        onTreeViewSelectionChanged($event, 'endpapers')
                      "
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" cssClass="calc-form-input-item">
            <dxi-item
              [visible]="collectedAdditionalInformation?.endpapers?.['requiresInput'] == true"
              itemType="group"
              name="endpapersInput"
            >
              <dxi-item
                editorType="dxTextBox"
                dataField="requiredInput.endpapersWeight"
                cssClass="calc-form-input-item"
              >
                <dxo-label text="Width"> </dxo-label>
              </dxi-item>
              <dxi-item
                dataField="requiredInput.endpapersColor"
                cssClass="calc-form-input-item"
              >
                <dxo-label text="Color"> </dxo-label>
              </dxi-item>
            </dxi-item>
          </dxi-item>
        </dxi-item>

        <dxi-item dataField="headFoot" [colSpan]="headFootWidth">
          <div class="dx-field-label line-height-center">
            <label>{{
              formatMessage("calculator.calculation.us.headFoot")
            }}</label>
          </div>
          <div class="dx-field-value">
            <dx-drop-down-box
              [(value)]="calculationData.headFoot"
              valueExpr="id"
              displayExpr="displayExpr"
              placeholder="Select head/foot..."
              [showClearButton]="true"
              [dataSource]="headFootDataSource"
              (onValueChanged)="onDropDownBoxValueChanged($event, 'headFoot')"
              valueChangeEvent=""
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  #headFootTree
                  [dataSource]="headFootDataSource"
                  dataStructure="plain"
                  keyExpr="id"
                  parentIdExpr="categoryId"
                  selectionMode="single"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTreeViewSelectionChanged($event, 'headFoot')
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>

        <dxi-item dataField="pack" [colSpan]="packWidth">
          <div class="dx-field-label line-height-center">
            <label>{{ formatMessage("calculator.calculation.us.pack") }}</label>
          </div>
          <div class="dx-field-value">
            <dx-drop-down-box
              [(value)]="calculationData.pack"
              valueExpr="id"
              displayExpr="displayExpr"
              placeholder="Select packaging..."
              [showClearButton]="true"
              [dataSource]="packDataSource"
              (onValueChanged)="onDropDownBoxValueChanged($event, 'pack')"
              valueChangeEvent=""
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  #packTree
                  [dataSource]="packDataSource"
                  dataStructure="plain"
                  keyExpr="id"
                  parentIdExpr="categoryId"
                  selectionMode="single"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTreeViewSelectionChanged($event, 'pack')
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>
        <dxi-item
          itemType="group"
          [colSpan]="shipmentWidth"
          cssClass="calc-form-input-group"
        >
          <dxi-item itemType="group">
            <dxi-item dataField="shipment">
              <div class="dx-field-label line-height-center">
                <label>{{
                  formatMessage("calculator.calculation.us.shipment")
                }}</label>
              </div>
              <div class="dx-field-value">
                <dx-drop-down-box
                  [(value)]="calculationData.shipment"
                  valueExpr="id"
                  displayExpr="displayExpr"
                  placeholder="Drop Shipment..."
                  [showClearButton]="true"
                  [dataSource]="shipmentDataSource"
                  (onValueChanged)="
                    onDropDownBoxValueChanged($event, 'shipment')
                  "
                  valueChangeEvent=""
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      #shipmentTree
                      [dataSource]="shipmentDataSource"
                      dataStructure="plain"
                      keyExpr="id"
                      parentIdExpr="categoryId"
                      selectionMode="single"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="
                        onTreeViewSelectionChanged($event, 'shipment')
                      "
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" cssClass="calc-form-input-item">
            <dxi-item
              [visible]="collectedAdditionalInformation?.shipment?.['requiresInput'] == true"
              itemType="group"
              name="shipmentInput"
            >
              <dxi-item
                dataField="requiredInput.shipmentAmount"
                cssClass="calc-form-input-item"
              >
                <dxo-label text="Amount"> </dxo-label>
              </dxi-item>
            </dxi-item>
          </dxi-item>
        </dxi-item>
      </ng-template>
    </dxi-item>
    <dxi-item itemType="group" [colCount]="6" [colCountByScreen]="{ xs: 1 }">
      <dxi-item style="padding-top: 1.5em" [colSpan]="6">
        <div *dxTemplate="let data">
          <dx-button
            icon="add"
            style="margin-top: 1rem"
            [disabled]="additionalSpecButtonDisabled"
            [text]="
              formatMessage(
                'calculator.calculation.us.button.additionalSpecification'
              )
            "
            (onClick)="onAddSpecButtonSelected()"
            [useSubmitBehavior]="true"
          >
          </dx-button>
        </div>
      </dxi-item>
    </dxi-item>
  </dx-form>

  <div class="form-buttons">
    <dx-button
      icon="todo"
      [text]="formatMessage('calculator.button.calculate')"
      (onClick)="calculate()"
      [useSubmitBehavior]="true"
      type="default"
    >
    </dx-button>
    <span>* Required fields</span>
  </div>
</div>

<app-calculator-us-price-table
  class="calc-box"
  *ngIf="calculationResponse"
  [calculationResponse]="calculationResponse"
  [calculationTableConfig]="calculationTableConfig"
  [quantities]="quantities"
  [responseAncillaryGroupTypes]="responseAncillaryGroupTypes"
></app-calculator-us-price-table>

<div class="dx-card" style="margin-top: 2em" *ngIf="calculationResponse">
  <div class="form-buttons">
    <dx-button
      icon="pdffile"
      style="margin-top: 0"
      [text]="formatMessage('calculator.button.createPdf')"
      (onClick)="downloadPdf()"
      [useSubmitBehavior]="true"
      type="default"
    >
    </dx-button>
  </div>
</div>
<app-action-popup
  [(visible)]="showAdditionalSpecifications"
  maxWidth="40%"
  (onShowing)="(null)"
  title="Additional Specifications"
  (onSave)="submitOptionen()"
>
  <app-additional-specification-list
    [optionGroups]="additionalOptionGroups"
    [selectedProduct]="selectedProduct"
  ></app-additional-specification-list>
</app-action-popup>
